import React, { useEffect, useState } from "react";
import { Box, Button, MenuItem, TextField } from "@material-ui/core";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { BaseItemState, OverviewCriteria } from "../Ticker2/Ticker2Models";
import FixtureOverviewUtil from "./FixtureOverviewUtil";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import Ticker2Util from "../Ticker2/Ticker2Util";
import FixtureNgTable from "./FixtureNgTable";
import { ActionState, FixtureNgItem, ExtFixtureFilter, FixtureNg, FixtureOdds } from "./FixtureOverviewModels";
import { Fixture } from "../TeamOverview/TeamOverviewModels";
import { League } from "../LeagueOverview/LeagueModels";
import { GenericResponse, LeagueListItem } from "../CreateRound/CreateRoundModels";
import { ListResponse } from "../api/ApiNgModels";
import { UpdateItemState } from "../CreateSyndicate/CreateSyndicateModels";
import { blue } from "@material-ui/core/colors";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import { RoundOverviewItem } from "../RoundOverview/RoundOverviewModels";
import MapFixtureNgDialog from "./MapFixtureToFixtureNgDialog";
import OperatorSelect from "../Components/OperatorSelect";
import AdminUtil from "../Admin/AdminUtil";
import { toBooleanOrDefault } from "../common/helpers/StringUtils";
import { ALL_ITEM_KEY } from "../Components/ItemSelect";
import FixtureOddsTable from "./FixtureOddsTable";


interface FixtureOddsItemState extends BaseItemState<FixtureOdds, number> {
    fixtureId: number;
    operatorId: string;
}

interface FixtureOddsViewState {
    operatorId: string;
}

interface FixtureOddsViewProps {
    fixture?: Fixture;
    // round?: RoundOverviewItem;
}
const FixtureOddsView: React.FC<FixtureOddsViewProps> = (props) => {
    var propsFixtureId = 0;
    var propsFixtureName = "";
    var propsLeagueId = 0;
    // var propsRoundId = 0;
    if (props.fixture) {
        propsFixtureId = props.fixture.id;
        propsFixtureName = props.fixture.name;
    }
    if (props.fixture) {
        propsLeagueId = props.fixture.leagueId;
    }
    // if (props.round) {
    //     propsRoundId = props.round.id;
    // }
    const [formState, setFormState] = useState<FixtureOddsViewState>({
        operatorId: ""
    });
    const [itemState, setItemState] = useState<FixtureOddsItemState>({
        fixtureId: propsFixtureId,
        operatorId: "",
        items: [],
        more: false,
        lastId: 0,
        refreshing: false
    });
    const [operatorItemState, setOperatorItemState] = useState<BaseItemState<string, number>>({
        items: [],
        more: false,
        lastId: 0,
        refreshing: false
    });
    const [actionState, setActionState] = useState<ActionState>(FixtureOverviewUtil.createEmptyActionState());

    useEffect(() => {
        refreshOperators("Init");
        refreshItems("Init");
    }, []);

    const handleChange = (name: string, value:any) =>{
        var valueX = value;
        if (name === "operatorId" && value === ALL_ITEM_KEY) {
            valueX = "";
        }
        var fs = {...formState, [name]: valueX};
        setFormState(fs);
    }

    const refreshOperators = (caller: string) => {
        const methodName = "refreshOperators";
        if (operatorItemState.refreshing) {
            return;
        }
        var ast = FixtureOverviewUtil.createEmptyActionState();
        var rs : BaseItemState<string, number> = {
            items: [],
            more: false,
            lastId: 0,
            refreshing: false
        }
       var lastId = caller === "onMore" ? itemState.lastId : 0;
        if (lastId > 0) {
            rs.items = operatorItemState.items;
        }
        var success = false;
        operatorItemState.refreshing = true;
        setActionState(FixtureOverviewUtil.createActionState(true, false, `${methodName}(${caller})...`));
        AdminUtil.getOperatorSettingsByName("OddsFeed.Enabled", 100, lastId).then( resp => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `${methodName}(${caller}) error: ${resp.message}`;
                rs.error = ast.message;
                return;
            }
            var listResponse = resp.item;
            if (listResponse) {
                if (listResponse.items) {
                    for (const item of listResponse.items) {
                        var oddsEnabled = toBooleanOrDefault(item.settingValue, false);
                        if (oddsEnabled) {
                            rs.items.push(item.operatorId);
                        }
                    }
                    if (listResponse.items.length > 0) {
                        rs.lastId = listResponse.items[listResponse.items.length - 1].id;
                    }
                    if (listResponse.pageSize > 0 && listResponse.pageSize <= listResponse.items.length) {
                        rs.more = true;
                    }
                }           
            }
            success = true;
        }).catch( error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `${methodName}(${caller}) error`);
            rs.error = ast.message;
        }).finally( () => {
             if (success || lastId <= 0) {
                setOperatorItemState(rs);
            }
            operatorItemState.refreshing = false;
            setActionState(ast);
        });
    };
    const getFixtureOddss = async (): Promise<GenericResponse<FixtureOdds[]>> => {
        return await FixtureOverviewUtil.getFixtureOdds(propsFixtureId, formState.operatorId);
    };
    const refreshItems = (caller: string) => {
        if (itemState.refreshing) {
            return;
        }
        var ast = FixtureOverviewUtil.createEmptyActionState();
        var rs : FixtureOddsItemState = {
            fixtureId: propsFixtureId,
            operatorId: formState.operatorId,
            items: [],
            more: false,
            lastId: 0,
            refreshing: false
        }
        if (propsFixtureId <= 0) {
            setItemState(rs);
            return;
        }
        var success = false;
        itemState.refreshing = true;
        setActionState(FixtureOverviewUtil.createActionState(true, false, `RefreshItems(${caller})...`));
        getFixtureOddss().then( resp => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `RefreshItems(${caller}) error: ${resp.message}`;
                rs.error = ast.message;
                return;
            }
            var items = resp.item;
            if (items) {
                rs.items = items;
            }
            success = true;
        }).catch( error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `RefreshItems(${caller}) error`);
            rs.error = ast.message;
        }).finally( () => {
            if (success) {
                setItemState(rs);
            }
            itemState.refreshing = false;
            setActionState(ast);
        });
    };
    const onRefreshItems = () => {
        refreshItems("Refresh");
    };
      
    var isExecuting = itemState.refreshing || actionState.executing || operatorItemState.refreshing;
    var actionBox = null;
    if ((actionState.executing || actionState.error) && actionState.message.length > 0) {
        actionBox = (
            <Box color={actionState.error ? RoundOverviewUtil.INVALID_COLOR : blue[500]} fontSize={12}>
                {actionState.message}
            </Box>
        );
    }

    if (!isExecuting && itemState.fixtureId !== propsFixtureId) {
        itemState.fixtureId = propsFixtureId;
        itemState.items = [];
        refreshItems("ChangeCriteria");
    }
    var selectedOperatorIdValue = formState.operatorId;
    if (selectedOperatorIdValue === "") {
        selectedOperatorIdValue = ALL_ITEM_KEY;
    }
    var info = Ticker2Util.toItemStateString(itemState);
    var operatorInfo = Ticker2Util.toItemStateString(operatorItemState);


    return (
        <div>
               <Box fontSize={10} marginTop={2}>
                 <TextField
                    label="Opererator"
                    select
                    name="operatorId"
                    value={selectedOperatorIdValue}
                    onChange={e => handleChange("operatorId", e.target.value)}
                    style={{width:200, marginRight:"5px"}}
                >
                    <MenuItem key={"op_all"} value={ALL_ITEM_KEY}>
                        {"(All)"}
                    </MenuItem>
                     {operatorItemState.items.map(opId => (
                    <MenuItem key={`opId_${opId}`} value={opId}>
                        {opId}
                    </MenuItem>
                    ))}
                </TextField>
                <Button 
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={isExecuting}
                    style={{marginRight: "5px"}}
                    onClick={e => onRefreshItems()}>
                    Search
                </Button>
            </Box>
            <Box fontSize={10}>
                {info}
            </Box>
            <FixtureOddsTable items={itemState.items} />
        </div>
    );
};

export default FixtureOddsView;

